import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ttContentCardSx } from "./timeTrackingStyles";

/**
 * Envuelve el contenido de una pestaña con la tarjeta gradiente de Fichaje.
 */
const TabContentShell = ({
  children,
  accentColor,
  maxWidth,
  centered = false,
  sx,
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        ...ttContentCardSx(theme, accentColor, { maxWidth, centered }),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default TabContentShell;
